<template>
  <FontAwesomeIcon
    v-bind="{ ...$props, ...$attrs }"
    :class="{
      ['d-print-none']: !print,
    }"
    :icon="iconToUse"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ApplicationDefaults } from '@/constants/ApplicationDefaults';

export default defineComponent({
  name: 'Icon',
  components: {
    FontAwesomeIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    fas: {
      type: [String, Boolean],
      required: false,
    },
    fat: {
      type: [String, Boolean],
      required: false,
    },
    fak: {
      type: [String, Boolean],
      required: false,
    },
    fab: {
      type: [String, Boolean],
      required: false,
    },
    size: {
      type: String as PropType<SizeProp>,
      required: false,
    },
    fixedWidth: {
      type: Boolean,
      required: false,
    },
    rotation: {
      type: Number as PropType<90 | 180 | 270>,
      required: false,
    },
    flip: {
      type: String as PropType<'horizontal' | 'vertical' | 'both'>,
      required: false,
    },
    /**
     * If true, include this icon when printing.
     *
     * By default this is false.
     */
    print: {
      type: Boolean,
      default: false,
    },
    transform: {
      type: Object as PropType<{ rotate: number }>,
      required: false,
    },
  },
  setup(props) {
    /**
     * List of icons substring where we should use the solid variant for the
     * icon.
     */
    const solidIcons = ['caret', 'sort', 'cog', 'thumb-tack', 'plus', 'bars', 'seal'];

    const variant = computed(() => {
      for (const icon of solidIcons) {
        if (props.icon.includes(icon)) return 'fas';
      }

      if (props.fas !== undefined && props.fas !== false) {
        return 'fas';
      }

      if (props.fat !== undefined && props.fat !== false) {
        return 'fat';
      }

      if (props.fak !== undefined && props.fak !== false) {
        return 'fak';
      }

      if (props.fab !== undefined && props.fab !== false) {
        return 'fab';
      }

      return ApplicationDefaults.iconSet;
    });

    const iconToUse = computed(() => `${variant.value} fa-${props.icon}`);

    return {
      iconToUse,
    };
  },
});
</script>
